export const EVALUATE_FUNDING_OPTIONS_ENTRY_POINTS = {
  ADD_FI: 'add_fi',
  CANCEL_ADD_FI: 'cancel_add_fi',
  REFRESH_FI: 'refresh_fi',
  UNLINK_FI: 'unlink_fi',
  FLOW_CONTINGENCY: 'flow_contingency',
  CHANGE_FI: 'change_fi',
  REQUEST_PHYSICAL_CARD_CHANGE_FI: 'request_physical_card_change_fi',
  REQUEST_PHYSICAL_CARD_ADD_FI: 'request_physical_card_add_fi',
  REQUEST_PHYSICAL_CARD_CANCEL_ADD_FI: 'request_physical_card_cancel_add_fi',
} as const

export type EvaluateFundingOptionsEntryPoint = (typeof EVALUATE_FUNDING_OPTIONS_ENTRY_POINTS)[keyof typeof EVALUATE_FUNDING_OPTIONS_ENTRY_POINTS]
